import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { CategoriaEquipamentoDBService } from '../database/categoria-equipamento-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class CategoriaEquipamentoService extends BaseService{
    override classname: string = 'CategoriaEquipamentoService';
    public override route: string = 'categoria-equipamento';
    public override database = Capacitor.isNativePlatform() ? new CategoriaEquipamentoDBService() : new CategoriaEquipamentoDBService();
}
